import { useEffect } from 'react';

const useDocumentAttribUpdater = (attributes: Record<string, string>) => {
  useEffect(() => {
    const docElement = document.documentElement;
    for (let key in attributes) {
      docElement.setAttribute(key, attributes[key]);
    }
  }, Object.values(attributes));
};

export default useDocumentAttribUpdater;
